import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./index.css";
import "tippy.js/dist/tippy.css";

// Tailwind css
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { FunnelController, TrapezoidElement } from "chartjs-chart-funnel";
import ChartDataLabels from "chartjs-plugin-datalabels";
import App from "./App";
import ReusableToast from "./components/custom/custom-toast";
import { ExpiredProvider } from "./state/expired-context";
import { LoadingProvider } from "./state/loading-context";
import "./tailwind.css";
ChartJS.register(
  CategoryScale,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  FunnelController,
  TrapezoidElement
);
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

declare global {
  interface Window {
    env: any;
  }
}
root.render(
  <ExpiredProvider>
    <LoadingProvider>
      <Suspense>
        <Provider store={store}>
          <App />
          <ReusableToast />
        </Provider>
      </Suspense>
    </LoadingProvider>
  </ExpiredProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();